<template>
  <div v-if="cancel">
    <SEntrega99Cancel @save="onSave" @cancel="onCancel" />
  </div>
  <div v-else>
    <div v-if="showConfig" class="s-card" style="margin: 5px 2px; ">
      <table style="width: 100%">
        <tr>
          <td style="width: 100%;" colspan="2">
            <s-onoff v-model="value.active" text="99Entrega"></s-onoff>
          </td>
        </tr>
        <tr>
          <td style="text-align: right">
            <label>Client id:</label>
          </td>
          <td style="width: 280px;">
            <input v-model="value.clientId" style="width: 100%" maxlength="100">
          </td>
        </tr>
        <tr>
          <td style="text-align: right">
            <label>Client secret:</label>
          </td>
          <td>
            <input v-model="value.clientSecret" style="width: 100%"
              maxlength="100">
          </td>
        </tr>
        <tr>
          <td style="text-align: right">
            <label>Key signature (webhook):</label>
          </td>
          <td>
            <input v-model="value.keySignature" style="width: 100%"
              maxlength="100">
          </td>
        </tr>
      </table>
    </div>
    <SEntrega99Info :value="value" :status="status" :showConfig="showConfig"
      @save="onSave" @disable="onDisable" @cancel="onCancel" />
  </div>
</template>

<script>
import SEntrega99Info from "./SEntrega99Info.vue";
import SEntrega99Cancel from "./SEntrega99Cancel.vue";

export default {
  name: "s-entrega99",
  components: { SEntrega99Info, SEntrega99Cancel },
  props: {
    value: { type: Object, default: () => ({}) },
    showConfig: { type: Boolean, default: false },
    cancel: { type: Boolean, default: false },
    status: { type: String, default: "" },
  },
  methods: {
    onSave(info) {
      this.$emit("save", this.showConfig ? this.value : info);
    },
    onDisable() {
      this.$emit("disable");
    },
    onCancel() {
      this.$emit("cancel");
    },
  },
};
</script>